<h1 mat-dialog-title>Step to get a google map link</h1>
<div mat-dialog-content>
  <ul>
    <li>Open Google Map & Select your shop location</li>
    <li>Click a share button</li>
    <li>Click a 'COPY LINK' & Paste your Google Map link</li>
  </ul>
</div>
<div mat-dialog-actions class="f-right">
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</div>
